import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Container } from "reactstrap";
import { Loader } from "../../components";
import RegisterFree from "../../components/RegisterFree";
import { appUrl } from "../../redux/base/types/url";
import { getFaqs, getPackages } from "../../redux/homepage/saga";
import { languagesSelector } from "../../redux/languages";
import { FaqsDto, PackageDto } from "../../redux/homepage/type";
import { getLocalization } from "../../redux/localization";
import PackageCard from "./packageCard";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";
import images from "../../assets/images";

const Pricing = () => {
  const [google, setGoogle] = useState<any>();
  const languages = useSelector(languagesSelector);
  const [googlefaq, setGooglefaq] = useState<any>();
  const t = useSelector(getLocalization);
  const [active, setActive] = useState<"mo" | "ye">("mo");
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const [data, setData] = useState<PackageDto[]>([]);
  const [faqsList, setFaqsList] = useState<FaqsDto[]>([]);
  useEffect(() => {
    setLoader(true);
    dispatch(
      getPackages({
        payload: {
          onSuccess: (message, payload, details) => {
            setData(payload);
            setLoader(false);
            setGoogle(details);
          },
          onError: () => {},
        },
      })
    );
    dispatch(
      getFaqs({
        payload: {
          onSuccess: (message, payload, details) => {
            setFaqsList(payload);
            setGooglefaq(details);
          },
          onError: () => {},
        },
      })
    );
  }, [dispatch]);
  const location = useLocation();
  const title = t.getString("PricingSeoTitle");
  const desc = t.getString("PricingSeoDescription");
  return (
    <React.Fragment>
      <Helmet>
      <title>Pricing Plans | Rentificial Car Rental Software</title>
<meta name="description" content="Flexible and affordable pricing plans for Rentificial’s smart car rental software. Start free, grow as you scale." />
<meta name="keywords" content="car rental software pricing, Rentificial plans, fleet software cost, freemium rental software, rental management plans" />
<link rel="canonical" href="https://www.rentificial.com/pricing/" />

        {google && (
          <script type="application/ld+json">
            {`${JSON.stringify(google)}
                `}
          </script>
        )}
        {googlefaq && (
          <script type="application/ld+json">
            {`${JSON.stringify(googlefaq)}
                `}
          </script>
        )}
        
        {/* <link
          rel="alternate"
          hrefLang="x-default"
          href={appUrl + "/solutions"}
        />
        {languages.map((x) => {
          let code = x.Code.split("-")[0];
          return (
            <link
              rel={code === "en" ? "canonical" : "alternate"}
              hrefLang={code}
              href={appUrl + "/" + code + "/solutions"}
            />
          );
        })} */}
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={title} />
        <meta name="twitter:image" content={images.logoColored} />
        <meta name="twitter:card" content={"large_summary_card"} />
        <meta name="twitter:site" content="@rentificial" />
        <meta name="twitter:creator" content="@rentificial" />
        <meta property="og:title" content={title} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={desc} />
        <meta property="og:image" content={images.logoColored} />

        <meta
          property="og:url"
          content={"https://www.rentificial.com" + location.pathname}
        />
        {
          <script type="application/ld+json">
            {`
                {
                  "@context": "https://schema.org",
                  "@type": "BreadcrumbList",
                  "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Anasayfa",
                    "item": ${appUrl}
                  },{
                    "@type": "ListItem",
                    "position": 2,
                    "name": "${t.getString("PricingHelmet")}"
                    "item": ${appUrl}+"/pricing"
                  }]
                }`}
          </script>
        }
      </Helmet>
      <div className=" defaultPage ">
        <div className="pricingPage">
          <Container>
            {loader && <Loader />}
            <h1>
              {t.getString("Choose the Plan That Fits Your Business Needs")}
            </h1>
            <p>
              {t.getString(
                "No commission fee or contract You can cancel anytime"
              )}
            </p>
            <div>
              <div className="switches-container">
                <input
                  type="radio"
                  id="switchMonthly"
                  name="switchPlan"
                  value="Monthly"
                  checked={active === "ye" ? false : true}
                />
                <input
                  type="radio"
                  id="switchYearly"
                  name="switchPlan"
                  value="Yearly"
                  checked={active === "mo" ? false : true}
                />
                <label htmlFor="switchMonthly" onClick={() => setActive("mo")}>
                  {t.getString("Monthly")}
                </label>
                <label htmlFor="switchYearly" onClick={() => setActive("ye")}>
                  {t.getString("Yearly")}
                </label>
                <div className="switch-wrapper">
                  <div className="switch">
                    <div> {t.getString("Monthly")}</div>
                    <div> {t.getString("Yearly")}</div>
                  </div>
                </div>
              </div>
            </div>
            <Row>
              {data
                .sort((a, b) => a.Order - b.Order)
                .map((x) => (
                  <Col md={3}>
                    <PackageCard key={x.Id} isMonth={active} data={x} />
                  </Col>
                ))}
            </Row>

            <div className="pb-3">
              <RegisterFree />
            </div>
          </Container>
        </div>

        <div className="pricingSeperator">
          <h2>{t.getString("Join Our 1000+ Happy customers")}</h2>
        </div>
    <div className="container"><div className="faqs row"><h3>Faq's</h3><div className="mb-2 col-md-6"><h4>How does Rentificial work?</h4><p>Rentificial is a comprehensive rental management software that helps streamline and automate your rental business processes, from reservations and inventory management to invoicing and reporting.</p></div><div className="mb-2 col-md-6"><h4>Does Rentificial support multiple rental locations?</h4><p>Yes, Rentificial supports multiple rental locations, allowing you to manage inventory, reservations, and operations across various branches or rental outlets.</p></div><div className="mb-2 col-md-6"><h4>Does Rentificial provide customer support?</h4>
    
    <p>Yes, Rentificial provides dedicated customer support to assist you with any questions or issues you may have while using the software.</p></div>
    <div className="mb-2 col-md-6"><h4>Is Rentificial suitable for both small and large rental businesses?</h4>
    <p>Absolutely! Rentificial caters to rental businesses of all sizes, providing scalable solutions to manage rentals efficiently.</p></div>
    <div className="mb-2 col-md-6"><h4>How can I get started with Rentificial?</h4>
    <p>Getting started with Rentificial is easy. Simply visit our website, sign up for a free trial, and our team will guide you through the setup process to start managing your rentals efficiently.</p></div><div className="mb-2 col-md-6"><h4>Can Rentificial integrate with other software or platforms?</h4><p>Yes, Rentificial offers integrations with popular third-party software and platforms, such as online marketplaces, payment gateways, and accounting systems, to enhance your rental operations.</p></div><div className="mb-2 col-md-6"><h4>Can I customize Rentificial to fit my specific rental business needs?</h4><p>Yes, Rentificial offers customizable features and settings to adapt to the unique requirements of your rental business.</p></div><div className="mb-2 col-md-6"><h4>Can Rentificial help me optimize pricing for my rentals?</h4><p>Yes, Rentificial offers dynamic pricing optimization tools, allowing you to adjust rental rates based on factors like demand, seasonality, and competitor analysis to maximize revenue.</p></div><div className="mb-2 col-md-6"><h4>Does Rentificial offer training and onboarding for new users?</h4><p>Yes, Rentificial provides comprehensive training and onboarding sessions to help you and your team get up to speed with the software quickly and effectively.</p></div><div className="mb-2 col-md-6"><h4>Is my rental data secure with Rentificial?</h4><p>Absolutely. Rentificial employs advanced security measures and data encryption to ensure the confidentiality and integrity of your rental data.</p></div><div className="text-center col-md-12"><h4 className=" ">Still you have any questions?</h4><p className="emailContent "></p></div></div></div>
      </div>
    </React.Fragment>
  );
};
export default Pricing;
